import { formattedDateTime } from "@/lib/Util";

export function formateDateTime(value: string) {
  if (value) {
    return formattedDateTime(value);
  }
  return;
}